/**
 * @generated SignedSource<<24174e7df7e53c16c1191bbca6d7fd28>>
 * @relayHash d5ac1e00b105a39a55268d1ead20afd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID da22edef5d0e2bb25a60aabe6c57dc5a74a929652eb27fda107518adcafeae77

import type { ConcreteRequest } from 'relay-runtime';
export type TeamTypeState = "ACTIVE" | "DELETE_IN_PROGRESS" | "%future added value";
export type DeleteTeamTypeMutation$variables = {
  id: string;
};
export type DeleteTeamTypeMutation$data = {
  readonly team: {
    readonly deleteTeamType: {
      readonly id: string;
      readonly state: TeamTypeState | null;
    } | null;
  } | null;
};
export type DeleteTeamTypeMutation = {
  response: DeleteTeamTypeMutation$data;
  variables: DeleteTeamTypeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "concreteType": "TeamMutation",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "TeamType",
        "kind": "LinkedField",
        "name": "deleteTeamType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "state"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "DeleteTeamTypeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteTeamTypeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "da22edef5d0e2bb25a60aabe6c57dc5a74a929652eb27fda107518adcafeae77",
    "metadata": {},
    "name": "DeleteTeamTypeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "634fd33ffaa84c804c5247282f645f5a";

export default node;
